export default "__VITE_ASSET__8djq00tr__"